/** Page size for dropdown/lookup requests that need all categories or brands. */
export const RETAIL_LOOKUP_PAGE_SIZE = 1000;
